<app-section>
    <app-section-header [title]="'Explora Países'"
        [descriptions]=
        "['Descubre una amplia variedad de países y encuentra el destino perfecto para tu futuro.', 'Explora países de diferentes continentes, conoce sus detalles y marca tus favoritos ❤️ para tenerlos siempre a la mano.']">
    </app-section-header>
    <app-countries-list></app-countries-list>
</app-section>